import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useTranslations } from "../../providers/TranslationsProvider";
import { ButtonsContainer, Container, Message, ResponseButton, } from "./InactivePrompt.styles";
const InactivePrompt = ({ onAnswer }) => {
    const translations = useTranslations();
    const buttonRef = useRef(null);
    useEffect(() => {
        buttonRef.current?.focus();
    }, []);
    return (_jsxs(Container, { children: [_jsx(Message, { children: translations("inactive__continue_watching_question") }), _jsxs(ButtonsContainer, { children: [_jsx(ResponseButton, { ref: buttonRef, "aria-label": translations("inactive__continue_watching_yes"), onClick: () => onAnswer(true), confirm: true, children: translations("inactive__continue_watching_yes") }), _jsx(ResponseButton, { "aria-label": translations("inactive__continue_watching_no"), onClick: () => onAnswer(false), children: translations("inactive__continue_watching_no") })] })] }));
};
export { InactivePrompt };
